import { InsuranceHero } from "../shared/InsuranceHero";

export const LifeHero = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Life Insurance",
    "serviceType": "Insurance",
    "category": "Life Insurance",
    "provider": {
      "@type": "InsuranceAgency",
      "name": "Allen Insurance Agency",
      "areaServed": "Illinois"
    },
    "description": "Comprehensive life insurance policies including term life, whole life, and universal life options.",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock"
    }
  };

  return (
    <InsuranceHero
      title="Life Insurance Protection"
      description="Secure your family's future with our comprehensive life insurance solutions. We help you provide financial security for your loved ones."
      jsonLd={jsonLd}
    />
  );
};